import { Module } from "@apis/index";
import DropDown from "@components/fields/dropdown";
import useConfig from "@hooks/useConfig";
import { RootState } from "@store/index";
import { Form, Formik } from "formik";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";

interface ModuleDropdownProps {
  name?: string;
  label?: string;
  placeholder?: string;
  isMultiple?: boolean;
  styleInput?: string;
  styleOptionsWrapper?: string;
  disabled?: boolean;
  onChange?: (val: any) => void;
}

const ModuleDropdown: React.FC<ModuleDropdownProps> = ({
  name = "moduleId",
  label = "Module",
  placeholder = "Select Module",
  isMultiple = false,
  styleInput,
  styleOptionsWrapper,
  disabled,
  onChange,
}) => {
  const { data: modules } = useSelector((state: RootState) => state.modules);
  const { bucketUrl } = useConfig();
  const options = modules.map((m) => ({
    id: m.id,
    name: m.name,
    image: m.icon
      ? `${bucketUrl}/${m.icon}`
      : m?.name === "Any Services"
        ? "/svgs/anyservicetitle.svg"
        : `/svgs/${m?.name?.toLowerCase()}title.svg`,
  }));

  useEffect(() => {
    Module.list({
      state: "modules",
      params: { isActive: true, isModule: true },
    });
  }, []);

  return (
    <DropDown
      disabled={disabled}
      name={name}
      label={label}
      options={options}
      titleAsKey="name"
      valueAsKey="id"
      styleInput={styleInput}
      styleOptionsWrapper={styleOptionsWrapper}
      placeholder={placeholder}
      isMultiple={isMultiple}
      onChange={onChange}
    />
  );
};

export default ModuleDropdown;
